import { render, staticRenderFns } from "./AgencySettings.vue?vue&type=template&id=48ee9974&scoped=true&"
import script from "./AgencySettings.vue?vue&type=script&lang=js&"
export * from "./AgencySettings.vue?vue&type=script&lang=js&"
import style0 from "./AgencySettings.vue?vue&type=style&index=0&id=48ee9974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee9974",
  null
  
)

export default component.exports